<template>
    <div>
        <div class="select-header">
            <el-input
                v-if="levelSelect.filterInAll"
                class="mb5 filterInput"
                v-model="keyword"
                size="small"
                :placeholder="levelSelect.filterPlaceholder"
                :validate-event="false"
                clearable
            ></el-input>
            <div class="select-all" v-if="levelSelect.multiple && levelSelect.showSelectAll">
                <el-checkbox
                    :value="isSelectAll"
                    :indeterminate="!!selectedLength && selectedLength !== allLeafData.length"
                    @change="handleCheckAll"
                ></el-checkbox>
                <span>全选</span>
                <span>({{selectedLength}}/{{allLeafData.length}})</span>
            </div>
            <filter-tabs
                ref="filterTabs"
                v-if="(!keyword || !levelSelect.filterInAll) && levelSelect.tabConfig.length"
                @change="handleChangeTab"
            ></filter-tabs>
            <el-input
                v-if="!levelSelect.filterInAll"
                v-model="keyword"
                class="mt5 filterInput"
                size="small"
                :placeholder="levelSelect.filterPlaceholder"
                :validate-event="false"
                clearable
            ></el-input>
        </div>
        <div class="select-body">
            <options-wrapper ref="optionsWrapper" v-if="!keyword"></options-wrapper>
            <filter-options-wrapper v-else ref="filterOptionsWrapper"></filter-options-wrapper>
        </div>
    </div>
</template>
<script>
import OptionsWrapper from './OptionsWrapper';
import FilterOptionsWrapper from './FilterOptionsWrapper';
import FilterTabs from './FilterTabs';
import { getLeafData } from './model/utils';

export default {
    components: {
        OptionsWrapper,
        FilterOptionsWrapper,
        FilterTabs
    },
    inject: ['levelSelect'],
    data() {
        return {
            keyword: '',
            timeout: null
        };
    },
    watch: {
        keyword(val) {
            clearTimeout(this.timeout);
            if (!val) return;
            this.timeout = setTimeout(() => {
                this.$refs.filterOptionsWrapper.filter(val);
            }, 300);
        }
    },
    beforeDestroy() {
        clearTimeout(this.timeout);
    },
    computed: {
        selectedLength() {
            return this.levelSelect.store.selectedValue.length;
        },
        allLeafData() {
            return getLeafData(this.levelSelect.store.optData).filter(item => !item.disabled);
        },
        isSelectAll() {
            const { value } = this.levelSelect.store.getEmitValue();
            const allLeafValue = this.allLeafData.map(item => item[this.levelSelect.valueKey]);
            const concatData = Array.from(new Set(value.concat(allLeafValue)));
            // 如果全部的叶子节点值都在已选择的数据内，则全选
            return concatData.length === value.length;
        }
    },
    methods: {
        handleChangeTab() {
            if (this.keyword) {
                this.$refs.filterOptionsWrapper.filter(this.keyword);
            }
        },
        handleCheckAll(val) {
            const {maxSelectedCount} = this.levelSelect;
            if (val && this.allLeafData.length > maxSelectedCount) {
                // 选择数量限制
                return this.$message.warning(`选择失败，超出选择数量上限：${maxSelectedCount}`);
            }
            if (val) {
                // 全选
                this.levelSelect.store.handleSelectAll();
                return;
            }
            // 清空选择
            this.levelSelect.store.handleClear();
        }
    }
};
</script>
<style lang="scss" scoped>
.select-header {
    padding: 0 10px 5px 10px;
}
.mt5 {
    margin-top: 5px;
}
.mb5 {
    margin-bottom: 5px;
}
.select-all {
    font-size: 12px;
}
.filterInput {
    /deep/ .el-input__validateIcon {
        // 修复展示两个clear的问题
        display: none;
    }
}
</style>
